import React from 'react';
import { SpinnerInner } from './spinner';

export default (props) => (
  <SpinnerInner {...props} big={false} />
);
